
import { useQuery } from "@tanstack/react-query";
import { supabase } from '@/lib/supabase';
import { Enrollment } from '@/types/classTypes';
import { toast } from 'sonner';

export const useStudentEnrollments = (studentId?: string) => {
  return useQuery({
    queryKey: ['studentEnrollments', studentId],
    queryFn: async () => {
      if (!studentId) return [];
      
      try {
        const { data, error } = await supabase
          .from('enrollments')
          .select(`
            *,
            class:classes!enrollments_class_id_fkey(
              id,
              name,
              level,
              is_event,
              event_date,
              organization_id,
              description,
              created_at
            )
          `)
          .eq('student_id', studentId);
          
        if (error) throw error;
        
        return (data || []).map(item => ({
          ...item,
          status: item.status || 'active'
        })) as Enrollment[];
      } catch (error) {
        console.error('Error fetching student enrollments:', error);
        toast.error('Failed to load student enrollments');
        return [];
      }
    },
    enabled: !!studentId,
  });
};
